/* eslint-env jquery */

angular.
module("dx.webapp.datetimeinput").
directive("dxDateinput", function dateinputDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			date: "=",
			placehold: "=",
			format: "=",
			onBlur: "<",
			minDate: "<",
		},
		templateUrl: "tmpl/datetimeinput/dateinput-directive.html",
		link: link,
	};

	function link($scope, element) {
		var $e = $(element[0]);
		var isOpen = false;

		var input = $e.find("input");
		input.css("zIndex", "10000");
		input.css("position", "relative");

		$scope.$watch("placehold", function placeholdWatch() {
			return input.attr("placeholder", $scope.placehold);
		});

		$scope.$watch("format", function formatWatch() {
			input.datepicker("option", "dateFormat", $scope.format);

			if ($scope.date.valueOf() > 0) {
				input.datepicker("setDate", $scope.date);
			}
		});

		$scope.$watch("date", function dateWatch() {
			if (!$scope.date.valueOf()) {
				input.val("");
			}
		});

		var options = {
			beforeShow: function beforeShow() {
				isOpen = true;
			},
			onClose: function onSelect() {
				isOpen = false;

				return $scope.$apply(function apply() {
					$scope.updateDateFromInput();
				});
			},
			minDate: $scope.minDate || new Date(),
			maxDate: new Date("9999-12-31"),
		};

		if ($scope.date.valueOf() > 0) {
			options.defaultDate = $scope.date;
		}

		input.datepicker(options);

		if ($scope.date.valueOf() > 0) {
			input.datepicker("setDate", $scope.date);
		}

		var button = $e.find("span");
		button.click(function click() {
			return input.datepicker("show");
		});

		$scope.updateDateFromInput = function updateDateFromInput() {
			// When clicking outside the text field the blur event will fire. We don't
			// want all click in the datepicker to be counted as blurs so if it's open
			// we just ignore the event.
			if (isOpen) {
				return;
			}

			var error = null;
			var inputValue = input.val();

			if (inputValue) {
				try {
					$.datepicker.parseDate($scope.format, inputValue);
				} catch (err) {
					error = "invaliddate";
				}
			} else {
				error = "nodate";
			}

			if (!error) {
				// Need to manually parse the date string to avoid timezone offset to be applied.
				// Parsing strings to Date objects are also "strongly discouraged due to browser
				// differences and inconsistencies." See
				// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
				var dateParts = inputValue.split("-");
				var fullYear = parseInt(dateParts[0], 10);
				var month = parseInt(dateParts[1], 10) - 1;
				var date = parseInt(dateParts[2], 10);

				// Set date to January 1 to avoid accidentally setting a date which
				// does not exist, e.g. February 31st when we use .setMonth().
				$scope.date.setDate(1);
				$scope.date.setMonth(0);

				$scope.date.setFullYear(fullYear);
				$scope.date.setMonth(month);
				$scope.date.setDate(date);
			}

			if ($scope.onBlur) {
				$scope.onBlur(error);
			}
		};
	}
});
